module.exports = __webpack_public_path__ + "static/media/ripple.88e36b60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ripple.svg
// module id = 806
// module chunks = 0